<script>
import CalendarResource from '@/resources/calendar'
import BoardResource from '@/resources/board'

export default {
    name: 'WelcomeScreen',
    components: {
        
    },
    computed: {
        mappedSimTypes() {
            let indexedTypes = {}
            for(let resource of this.calendarResources) {
                let attrs = resource.attributes

                if('undefined' === typeof indexedTypes[attrs.type]) {
                    indexedTypes[attrs.type] = {
                        costCents: attrs.cost_cents,
                        costUnit: attrs.cost_unit,
                        typeName: attrs.type_name
                    }
                }
            }
            
            return indexedTypes
        },
        calendarFilters() {
            const filters = {}

            if (this.$route.query.location) {
                filters['location'] = this.$route.query.location
            }

            return filters
        }
    },
    data() {
        return {
            loading: true,
            calendarResources: [],
            boardResources: [],
            lapResourcePagesMap: {}
        }
    },
    methods: {
        async getRelated() {
            this.calendarResources = await CalendarResource.filterAll(this.calendarFilters)
            this.boardResources = await BoardResource.filterAll({ active: true })

            let promises = this.boardResources.map(async (resource) => {
                return resource.getResults({ page_size: 5 }).then((result) => this.lapResourcePagesMap[resource.id] = result)
            })

            await Promise.all(promises)
        },
        tick() {
            if(this.$refs.carousel && this.currentSlide == 0) {
                this.restartAfter(this.mainScreenTimeout)
            } else {
                this.$refs.carousel.next()
            }
        }
    },
    async mounted() {
        await this.getRelated()
        this.loading = false
    },
}
</script>

<template>
    <div class="pricelist-main">
        <b-row>
            <b-col class="text-left">
                <h1>Precios del Simulador</h1>
                <ul class="list-unstyled">
                    <li v-for="(simType, i) in mappedSimTypes" :key="i" class="price-item">
                        <b-row>
                            <b-col>
                                {{ simType.typeName }}<span v-if="simType.typeName.match(/vr/gi)">*</span>
                            </b-col>
                            <b-col>
                                <strong>{{ currencySymbol() }}{{ moneyFormat(simType.costCents) }}</strong> {{ simType.costUnit }}
                            </b-col>
                        </b-row>
                    </li>
                </ul>
                <small class="text-muted">* La disponibilidad de VR varía, reserva mínima de 2 horas o más</small>
            </b-col>

            <b-col class="text-right">
                <h1 class="invisible">Lorem Ipsum</h1>
                <ul class="list-unstyled">
                    <li><b-img src="https://shiftos-assets-public.s3.us-west-1.amazonaws.com/shiftarcade-logo-web.png" width="350" style="margin-right: -5px;" /></li>
                    <li>Ahorra un 20% en todas tus carreras con <strong>{{ $appConfig('APEX_CLUB_NAME', 'Apex Club') }}!</strong></li>
                    <li><hr /></li>
                    <li><b-icon icon="instagram" /> ShiftArcade <b-icon icon="facebook" class="ml-3" /> ShiftArcade<b-icon icon="globe" class="ml-3" /> <strong>Shift</strong>Arcade.com</li>
                </ul>
            </b-col>
            <b-col md="2" class="text-center">
                <h1 class="invisible">Lorm</h1>
                <ul class="list-unstyled">
                    <li><b-img :src="require('@/assets/qr-link.svg')" /></li>
                    <li><small>Ver Disponibilidad</small></li>
                </ul>
            </b-col>
        </b-row>
    </div>
</template>

<style lang="scss">
.pricelist-main {
    zoom: 130%;
    overflow: hidden !important;
    color: #fff;
    height: 40%;
    min-height: inherit;
    width: 80%;
    position: absolute;
    bottom: 60px;
    left: 10%;

    img.flag {
        height: 24px;
        border-radius: 12px;
        border: 1px solid #fff;
    }
}
</style>
